import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Form, Input, message, Radio, Select, Button } from "antd";
import axios from "axios";
import {
  checkNumbervalue,
  checkSpecialCharacter,
  checkSpace,
  capitalize,
  checkAlphabets,
  capitaliseWithHyphen,
} from "../../../utils";
import Places from "../../../components/places";
import { APIs } from "../../../utils/worker";
import { HeaderWithBottomLine } from "./HeaderWithBottomLine";

export function AddressDetails({
  form,
  continueCallBack,
  cpResponse,
  disableInputField,
}) {
  const [pinDetails, setPinDetails] = useState();
  const [apiError, setApiError] = useState({});
  const [loading, setLoading] = useState(false);
  const [isMiniHub, setIsMiniHub] = useState(false);
  const [citySateOption, setcitySateOptionn] = useState([]);
  const [stateNames, setstateNames] = useState([]);
  const [pincodeData, setPincodeData] = useState([]);
  const [dynamicInput, setDynamicInput] = useState(0);
  const radioGap = {
    display: "flex",
    columnGap: "4rem",
  };

  const [pincodeDisable, setPincodeDisable] = useState(true);
  const [dynamicPincode, setDynamicPincode] = useState(true);

  const formRef = useRef(null);

  const handleAdd = (e) => {
    let temp = [];
    for (let i = 0; i < +e; i++) {
      temp.push({
        id: Math.random().toString(36).slice(2),
      });
    }
    setDynamicInput(temp);
  };

  const callMeback = (temp) => {
    for (let i = 0; i < temp.length; i++) {
      form.setFieldsValue({
        [`City${i}`]: temp[i].City,
        [`StateName${i}`]: temp[i].stateName,
        ["StateCode" + i]: temp[i].StateCode,
        ["AddressLine1" + i]: temp[i].AddressLine1,
        ["AddressLine2" + i]: temp[i].AddressLine2,
        ["PINcode" + i]: temp[i].PINcode,
      });
    }
  };

  useEffect(() => {
    if (cpResponse?.premiseSubBranch?.length > 0) {
      setIsMiniHub(true);
      let temp = [];
      for (let i = 0; i < +cpResponse?.premiseSubBranch?.length; i++) {
        temp.push({
          id: Math.random().toString(36).slice(2),
          City: cpResponse?.premiseSubBranch[i].city,
          stateName: cpResponse?.premiseSubBranch[i].state,
          StateCode: cpResponse?.premiseSubBranch[i].stateCode,
          AddressLine1: cpResponse?.premiseSubBranch[i].addressLine1,
          AddressLine2: cpResponse?.premiseSubBranch[i].addressLine2,
          PINcode: cpResponse?.premiseSubBranch[i].pincode,
        });
      }
      setDynamicInput(temp);
      callMeback(temp);
      // handleAdd(cpResponse?.premiseSubBranch?.length);
    }
  }, [cpResponse]);

  // const [apiError, setApiError] = useState({});

  const onPincodeSender = async (values) => {
    if (values.target.value.length > 5) {
      setLoading(true);

      try {
        let response = await fetch(
          `https://api.postalpincode.in/pincode/${values.target.value}`
        );
        let res = await response.json();

        if (res[0].Status == "Error") {
          form.setFieldsValue({
            City: null,
            StateName: null,
          });

          setLoading(false);
          if (res[0].Message === "No records found") {
            setApiError({
              validateStatus: "error",
              errorMsg: "Invalid pincode",
            });
          } else {
            setApiError({
              validateStatus: "error",
              errorMsg: res[0].Message,
            });
          }
        } else {
          let stateName;
          setPincodeData(res[0].PostOffice);

          form.setFieldsValue({
            City: res[0].PostOffice[0].District,
            StateName: res[0].PostOffice[0].State,
          });
          stateName = res[0]?.PostOffice[0].State;

          let uniqueStateNames = [];

          let uniqueArr = [];

          for (let i = 0; i < res[0].PostOffice.length; i++) {
            if (!uniqueStateNames.includes(res[0].PostOffice[i].State)) {
              uniqueStateNames.push(res[0].PostOffice[i].State);

              uniqueArr.push(res[0].PostOffice[i]);
            }
          }
          setstateNames(uniqueArr);
          getStateCode(stateName);
        }
        setPincodeDisable(true);
      } catch (error) {
        setLoading(false);
      }
    } else {
      setstateNames([
        "Andaman & Nicobar",
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chandigarh",
        "Chattisgarh",
        "Dadra & Nagar Haveli",
        "Daman & Diu",
        "Delhi",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jammu and Kashmir",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Ladakh",
        "Lakshadweep",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Pondicherry",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal",
      ]);
      setPincodeDisable(false);

      setcitySateOptionn([]);
      form.setFieldsValue({
        City: null,
        StateName: null,
        StateCode: null,
      });
    }
  };

  const getStateCode = async (stateName) => {
    setLoading(true);
    let response2 = await axios.get(
      `https://smile.hutechweb.com/smcs-cp/cp-onboarding/v1/stateCode/${stateName}`
    );

    form.setFieldsValue({
      StateCode: response2.data,
    });
    setApiError({
      validateStatus: "success",
      errorMsg: null,
    });
    setLoading(false);
  };
  const onPincodeSenderForDynamicInput = async (values, index) => {
    if (values.target.value.length > 5) {
      setLoading(true);

      try {
        let response = await fetch(
          `https://api.postalpincode.in/pincode/${values.target.value}`
        );
        let res = await response.json();

        if (res[0].Status == "Error") {
          form.setFieldsValue({
            [`City${index}`]: null,
            [`stateName${index}`]: null,
          });

          setLoading(false);
          // setApiError({
          //   ["PINcode" + index]: "error",
          //   errorMsg: res[0].Message,
          // });
          form.setFields([
            {
              name: "PINcode" + index,
              errorMsg: res[0].Message,
            },
          ]);
        } else {
          let stateName;
          let state = res?.map((data) => {
            // setErrorData(data);
            data?.PostOffice?.map((data) => {
              form.setFieldsValue({
                // City: data?.District,
                // StateName: data?.State,
                [`City${index}`]: data?.District,
                [`StateName${index}`]: data?.State,
              });
            });

            stateName = data?.PostOffice[0].State;
          });

          let response2 = await axios.get(
            `https://smile.hutechweb.com/smcs-cp/cp-onboarding/v1/stateCode/${stateName}`
          );

          form.setFieldsValue({
            ["StateCode" + index]: response2.data,
          });
          // setApiError({
          //   validateStatus: "success",
          //   errorMsg: null,
          // });
          form.setFields([
            {
              name: "PINcode" + index,
              errorMsg: null,
            },
          ]);
        }
      } catch (error) {
        setLoading(false);
      }
      setDynamicPincode(true);
    } else {
      setDynamicPincode(false);
      setstateNames([
        "Andaman & Nicobar",
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chandigarh",
        "Chattisgarh",
        "Dadra & Nagar Haveli",
        "Daman & Diu",
        "Delhi",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jammu and Kashmir",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Ladakh",
        "Lakshadweep",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Pondicherry",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal",
      ]);
      form.setFieldsValue({
        [`City${index}`]: null,
        [`StateName${index}`]: null,
        ["StateCode" + index]: null,
      });
    }
  };

  const setDetailsHandler = (lat, lng) => {
    form.resetFields(["Latitude", "Longitude"]);

    form.setFieldValue("Latitude", lat);
    form.setFieldValue("Longitude", lng);
  };

  let lg = 12;
  let sm = 24;
  let md = 12;
  let xs = 24;

  function validatePincode(rule, value, callback) {
    if (!/^[1-9][0-9]{5}$/.test(value)) {
      callback("Please enter a valid pincode!");
    } else {
      callback();
    }
  }

  const onChangeStatename = (a, v) => {
    let filteredArr = pincodeData.filter((item) => item.State === a);
    setcitySateOptionn(filteredArr);
    getStateCode(a);
    form.setFieldsValue({
      City: null,
    });
  };

  return (
    <>
      <Row
        gutter={40}
        className="global-form-row basic-details-conten"
        ref={formRef}
      >
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="AddressLine1"
            label={"Address line 1"}
            rules={[
              {
                required: true,
                message: "Enter address",
              },
              () => ({
                validator(rule, value = "") {
                  if (value.substring(1, 0) === " ") {
                    return Promise.reject("Invalid CP address");
                  } else {
                    return Promise.resolve();
                  }
                },
              }),
            ]}
          >
            <Input
              placeholder="Enter address"
              type="text"
              // maxLength={50}
              // disabled={disableInputField?.AddressLine1}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="AddressLine2"
            label={"Address line 2"}
            rules={[
              () => ({
                validator(rule, value = "") {
                  if (value.substring(1, 0) === " ") {
                    return Promise.reject("Invalid CP address");
                  } else {
                    return Promise.resolve();
                  }
                },
              }),
            ]}
          >
            <Input
              placeholder="Enter address"
              type="text"
              // maxLength={50}
              // disabled={disableInputField?.MotherHubName}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="PINcode"
            label={"PIN code"}
            validateStatus={apiError?.validateStatus}
            help={apiError?.errorMsg}
            rules={[
              { required: true, message: "Please enter a pin code" },
              () => ({
                validator(rule, value = "") {
                  if (value.length > 0 && value.length < 6) {
                    return Promise.reject("Pincode should be 6 digits");
                  } else {
                    return Promise.resolve();
                  }
                },

                validateTrigger: "onSubmit",
              }),
            ]}
            onKeyPress={(event) => {
              if (
                checkNumbervalue(event) ||
                checkSpecialCharacter(event) ||
                checkSpace(event)
              ) {
                event.preventDefault();
              }
            }}
          >
            <Input
              placeholder="Enter PIN code"
              type="text"
              maxLength={6}
              onChange={(e) => onPincodeSender(e)}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="StateName"
            label={"State name"}
            rules={[
              {
                required: true,
                message: "Please enter value",
              },
            ]}
          >
            <Select
              // className="app-selector"
              showSearch
              placeholder="Select State name"
              // options={miniHub}
              onChange={onChangeStatename}
              disabled={stateNames?.length > 0 ? false : true}
            >
              {stateNames.map((option) => (
                <Option
                  key={option?.State || option}
                  value={option?.State || option}
                >
                  {capitaliseWithHyphen(option?.State || option)}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="City"
            label={"City"}
            onKeyPress={(event) => {
              if (checkAlphabets(event)) {
                event.preventDefault();
              }
            }}
            rules={[
              {
                required: true,
                message: "Please enter value",
              },
            ]}
          >
            {/* <Input
              placeholder="City name"
              type="text"
              disabled={true}
              maxLength={20}
            /> */}
            {!citySateOption?.length > 0 ? (
              <Input
                placeholder="City name"
                type="text"
                disabled={pincodeDisable}
                maxLength={20}
              />
            ) : (
              <Select
                // className="app-selector"
                showSearch
                placeholder="Select city"
                // options={miniHub}
                disabled={citySateOption?.length > 0 ? false : true}
              >
                {citySateOption.map((option) => (
                  <Option key={option?.Name} value={option?.Name}>
                    {capitaliseWithHyphen(option?.Name)}
                  </Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>

        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="StateCode"
            label={"State code (with GST code)"}
            // onKeyPress={(event) => {
            //   if (checkAlphabets(event)) {
            //     event.preventDefault();
            //   }
            // }}
            rules={[
              {
                required: true,
                message: "Please enter value",
              },
            ]}
          >
            {!citySateOption?.length > 0 ? (
              <Input
                placeholder="City name"
                type="text"
                disabled={pincodeDisable}
                maxLength={20}
              />
            ) : (
              <Input
                placeholder="State code"
                type="text"
                maxLength={2}
                disabled={citySateOption?.length > 0 ? false : true}
                onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
              />
            )}
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="branchPresent"
            label={
              <span className="calculater-container-pikpin">
                Collection center present ?
              </span>
            }
          >
            <Radio.Group
              style={radioGap}
              onChange={(e) => setIsMiniHub(JSON.parse(e.target.value))}
              disabled={disableInputField?.branchPresent}
              defaultValue={false}
              value={isMiniHub}
              rules={[
                {
                  required: true,
                  message: "Please select value",
                },
              ]}
            >
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        {isMiniHub && (
          <Col lg={lg} md={md} sm={sm} xs={xs}>
            <Form.Item
              name="numberOfBranch"
              label={
                <span className="calculater-container-pikpin">
                  Number of Collection center
                </span>
              }
              rules={[
                {
                  required: true,
                  message: "Please enter value",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Enter number of collection"
                optionFilterProp="children"
                disabled={disableInputField?.numberOfBranch}
                onSelect={(e) => handleAdd(e)}
                // onSearch={onSearch}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={[
                  {
                    value: 1,
                    label: "1",
                  },
                  {
                    value: 2,
                    label: "2",
                  },
                  {
                    value: 3,
                    label: "3",
                  },
                  {
                    value: 4,
                    label: "4",
                  },
                  {
                    value: 5,
                    label: "5",
                  },
                  {
                    value: 6,
                    label: "6",
                  },
                  {
                    value: 7,
                    label: "7",
                  },
                  {
                    value: 8,
                    label: "8",
                  },
                  {
                    value: 9,
                    label: "9",
                  },
                  {
                    value: 10,
                    label: "10",
                  },
                ]}
              />
            </Form.Item>
          </Col>
        )}
      </Row>
      {}
      {/* <Col lg={lg} md={md} sm={sm} xs={xs}> */}
      {isMiniHub &&
        dynamicInput.length > 0 &&
        dynamicInput.map((element, index) => (
          <>
            <HeaderWithBottomLine text={`Collection ${index + 1}`} />
            <Row gutter={40} className="global-form-row basic-details-conten">
              <Col lg={lg} md={md} sm={sm} xs={xs}>
                <Form.Item
                  name={"AddressLine1" + index}
                  label={"Address line 1"}
                  rules={[
                    {
                      required: true,
                      message: "Enter address",
                    },
                    () => ({
                      validator(rule, value = "") {
                        if (value.substring(1, 0) === " ") {
                          return Promise.reject("Invalid CP address");
                        } else {
                          return Promise.resolve();
                        }
                      },
                    }),
                  ]}
                >
                  <Input
                    placeholder="Enter address"
                    type="text"
                    // maxLength={50}
                  />
                </Form.Item>
              </Col>
              <Col lg={lg} md={md} sm={sm} xs={xs}>
                <Form.Item
                  name={"AddressLine2" + index}
                  label={"Address line 2"}
                  rules={[
                    () => ({
                      validator(rule, value = "") {
                        if (value.substring(1, 0) === " ") {
                          return Promise.reject("Invalid CP address");
                        } else {
                          return Promise.resolve();
                        }
                      },
                    }),
                  ]}
                >
                  <Input
                    placeholder="Enter address"
                    type="text"
                    // maxLength={50}
                  />
                </Form.Item>
              </Col>
              <Col lg={lg} md={md} sm={sm} xs={xs}>
                <Form.Item
                  name={"PINcode" + index}
                  label={"PIN code"}
                  validateStatus={apiError?.validateStatus}
                  help={apiError?.errorMsg}
                  rules={[
                    { required: true, message: "Please enter a pin code" },
                  ]}
                  onKeyPress={(event) => {
                    if (
                      checkNumbervalue(event) ||
                      checkSpecialCharacter(event) ||
                      checkSpace(event)
                    ) {
                      event.preventDefault();
                    }
                  }}
                >
                  <Input
                    placeholder="Enter PIN code"
                    type="text"
                    maxLength={6}
                    onChange={(e) => onPincodeSenderForDynamicInput(e, index)}
                  />
                </Form.Item>
              </Col>
              <Col lg={lg} md={md} sm={sm} xs={xs}>
                <Form.Item
                  name={"City" + index}
                  label={"City"}
                  onKeyPress={(event) => {
                    if (checkAlphabets(event)) {
                      event.preventDefault();
                    }
                  }}
                  rules={[
                    {
                      required: true,
                      message: "Please enter value",
                    },
                  ]}
                >
                  <Input
                    placeholder="City name"
                    type="text"
                    disabled={dynamicPincode}
                    maxLength={20}
                  />
                </Form.Item>
              </Col>
              <Col lg={lg} md={md} sm={sm} xs={xs}>
                <Form.Item
                  name={"StateName" + index}
                  label={"State name"}
                  rules={[
                    {
                      required: true,
                      message: "Please enter value",
                    },
                  ]}
                >
                  {dynamicPincode ? (
                    <Input
                      placeholder="State name"
                      type="text"
                      maxLength={20}
                      onKeyPress={(event) => {
                        if (checkAlphabets(event)) {
                          event.preventDefault();
                        }
                      }}
                      disabled={true}
                    />
                  ) : (
                    <Select
                      // className="app-selector"
                      showSearch
                      placeholder="Select mini hub"
                      // options={miniHub}
                      onChange={onChangeStatename}
                      disabled={stateNames?.length > 0 ? false : true}
                    >
                      {stateNames.map((option) => (
                        <Option
                          key={option?.State || option}
                          value={option?.State || option}
                        >
                          {capitaliseWithHyphen(option?.State || option)}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col lg={lg} md={md} sm={sm} xs={xs}>
                <Form.Item
                  name={"StateCode" + index}
                  label={"State code (with GST code)"}
                  // onKeyPress={(event) => {
                  //   if (checkAlphabets(event)) {
                  //     event.preventDefault();
                  //   }
                  // }}
                  rules={[
                    {
                      required: true,
                      message: "Please enter value",
                    },
                  ]}
                >
                  <Input
                    placeholder="State code"
                    type="text"
                    maxLength={2}
                    disabled={dynamicPincode}
                    onInput={(e) =>
                      (e.target.value = e.target.value.toUpperCase())
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          </>
        ))}
      {/* </Col> */}
      <Row gutter={40} className="global-form-row basic-details-conten">
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
          style={{ paddingBottom: "10px" }}
        >
          <Places
            setDetailsHandler={(lat, lng) => setDetailsHandler(lat, lng)}
          />
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="Latitude"
            label={"Latitude"}
            onKeyPress={(event) => {
              if (
                // checkNumbervalue(event) ||
                // checkSpecialCharacter(event) ||
                checkSpace(event)
              ) {
                event.preventDefault();
              }
            }}
            rules={[
              // {
              //   required: true,
              //   message: "Please enter value",
              // },
              // {
              //   pattern: new RegExp(
              //     "^(\\+|-)?(?:90(?:(?:\\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\\.[0-9]{1,6})?))$"
              //   ),
              //   message: "Invalid Latitude",
              // },
              {
                pattern: new RegExp(/^[0-9-+]{2,3}[.]{1}[0-9]{1,15}$/g),
                message: "Invalid latitude",
              },
              // {
              //   pattern: /^\d{1,10}(\.\d{0,10})?$/,
              //   message: "Invalid Latitude",
              // },
            ]}
          >
            <Input
              placeholder="Enter latitude"
              type="text"
              maxLength={16}
              // disabled={disableInputField?.Latitude}
            />
          </Form.Item>
        </Col>
        <Col lg={lg} md={md} sm={sm} xs={xs}>
          <Form.Item
            name="Longitude"
            label={"Longitude"}
            onKeyPress={(event) => {
              if (
                // checkNumbervalue(event) ||
                // checkSpecialCharacter(event) ||
                checkSpace(event)
              ) {
                event.preventDefault();
              }
            }}
            rules={[
              // {
              //   required: true,
              //   message: "Please enter value",
              // },
              // {
              //   pattern: new RegExp(
              //     "^(\\+|-)?(?:180(?:(?:\\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\\.[0-9]{1,6})?))$"
              //   ),
              //   message: "Invalid Longitude",
              // },
              {
                pattern: new RegExp(/^[0-9-+]{2,3}[.]{1}[0-9]{1,15}$/g),
                message: "Invalid latitude",
              },
              // {
              //   pattern: /^\d{1,10}(\.\d{0,10})?$/,
              //   message: "Invalid Longitude",
              // },
            ]}
          >
            <Input
              placeholder="Enter longitude"
              type="text"
              maxLength={16}
              // disabled={disableInputField?.Longitude}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}
